export default "__VITE_ASSET__xqxa8M2p__"